import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Link, IconButton, InputLabel, OutlinedInput, Stack, SvgIcon, Typography, TextField, FormControl, InputAdornment, Divider } from '@mui/material'
import { MuiOtpInput } from 'mui-one-time-password-input'


/**
 * UnsaveCard is a React component that displays a confirmation dialog box when a user attempts to unsave a job.
 * It takes the following props:
 * - onClose: A function that is called when the component should close.
 * - onUnsave: A function that is called when the user confirms to unsave the job.
 * - title: A string indicating the title of the job to be unsave.
 * The component displays a card with a title and a message, and two buttons: a button to cancel the dialog and a button to confirm the unsave.
 * When the user clicks on the "Unsave Job" button, the component will update the job status and show a notification.
 * If the submission fails for any reason, an error notification is shown.
 * @param {{ onClose: function, onUnsave: function, title: string }} props The props for the component.
 * @returns {JSX.Element} The rendered dialog box component.
 */
const UnsaveCard = ({ onClose, onUnsave, title }) => {
    const [isRemoving, setIsRemoving] = useState(false);

    /**
     * Handles the unsave action by setting the isRemoving state to true
     * and invoking the onUnsave callback to unsave the job.
     */
    const handleRemove = () => {
        setIsRemoving(true);
        onUnsave();
    };

    return (
        <Box className="ext-job-dialog-wraper">
            <Stack justifyContent={'center'}>
                <Box sx={{ textAlign: 'center' }} mb={3}>
                    <Typography className="title" mb={1}>Unsave this job?</Typography>
                    <Typography className="info-text">This job will be removed from your “Saved Jobs” list but will remain available in the “Jobs Market” as long as it's active.</Typography>
                </Box>
                <Stack direction={{ xs: 'column-reverse', md: 'row' }} alignItems={'center'} spacing={2.5}>
                    <Button fullWidth variant="outlined" size="medium" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button fullWidth variant="contained" size="medium" onClick={handleRemove} disabled={isRemoving}>
                        {isRemoving ? 'Unsaving...' : 'Unsave Job'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    )
}

export default UnsaveCard;
